if (typeof MktoForms2 !== 'undefined') {
    // eslint-disable-next-line no-undef
    MktoForms2.whenReady(form => {
        form.onSuccess((values, followUpUrl) => {
            const formId = form.getId()
            const { pathname } = window.location

            // eslint-disable-next-line no-undef
            dataLayer.push({
                event: 'form_success',
                'gtm.elementId': formId,
                page_path: pathname,
            })

            console.log(dataLayer)
        })
    })
}
